import { useEffect, useState } from 'react';
import { AdminApiRequest, useAdminApi } from './adminApi';

/**
 * One read against the admin API, refetched when the request changes. `null`
 * skips it. Built for the previous-period call behind a comparison chip, so a
 * failure comes back as `null` (no chip) rather than an error to render.
 */
export function useAdminFetch<T>(req: AdminApiRequest | null): T | null {
  const { request } = useAdminApi();
  const [data, setData] = useState<T | null>(null);
  const key = req ? JSON.stringify(req) : null;

  useEffect(() => {
    let mounted = true;
    setData(null);
    if (key === null) return;
    request<T>(JSON.parse(key) as AdminApiRequest)
      .then((d) => mounted && setData(d))
      .catch(() => undefined);
    return () => {
      mounted = false;
    };
  }, [request, key]);

  return data;
}
